var _namedview, _namedview2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67.896004mm",
    height: "68.667999mm",
    viewBox: "3 3 67.896003 68.667999",
    id: "svg1",
    sodipodi: "gameTime.svg",
    inkscape: "1.3.2 (091e20e, 2023-11-25, custom)",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#111111",
    borderopacity: 1,
    showpageshadow: 0,
    pageopacity: 0,
    pagecheckerboard: 1,
    deskcolor: "#d1d1d1",
    "document-units": "mm",
    zoom: 3.6808527,
    cx: 107.85544,
    cy: 165.31495,
    "window-width": 2787,
    "window-height": 1586,
    "window-x": 8629,
    "window-y": 1582,
    "window-maximized": 1,
    "current-layer": "layer1"
  })), _namedview2 || (_namedview2 = /*#__PURE__*/React.createElement("namedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#111111",
    borderopacity: 1,
    showpageshadow: 0,
    pageopacity: 0,
    pagecheckerboard: 1,
    deskcolor: "#d1d1d1",
    "document-units": "mm",
    showguides: "true",
    zoom: 1.1911942,
    cx: 349.64912,
    cy: 297.60051,
    "window-width": 3728,
    "window-height": 2126,
    "window-x": 2869,
    "window-y": -11,
    "window-maximized": 1,
    "current-layer": "layer1"
  }, /*#__PURE__*/React.createElement("guide", {
    position: "75.800247,-29.83513",
    orientation: "1,0",
    id: "guide5",
    locked: "false"
  }), /*#__PURE__*/React.createElement("guide", {
    position: "32.040239,32.129911",
    orientation: "1,0",
    id: "guide16",
    locked: "false"
  }), /*#__PURE__*/React.createElement("guide", {
    position: "48.143653,37.183051",
    orientation: "0,-1",
    id: "guide17",
    locked: "false"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    label: "Layer 1",
    groupmode: "layer",
    id: "layer1",
    transform: "translate(-55.803502,-66.640622)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "none",
      stroke: "#cd1c21",
      strokeWidth: 3.329,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "path1",
    cx: 90.855431,
    cy: 101.16338,
    r: 28.27076
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#cd1c21",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.79282,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "path2",
    cx: 90.855431,
    cy: 101.16338,
    rx: 3.5402427,
    ry: 3.3544455
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#cd1c21",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.87728,
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    id: "rect2",
    width: 2.3322184,
    height: 6.7745385,
    x: 89.517693,
    y: 75.911438,
    ry: 0.89475042
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    href: "#rect2",
    id: "use2",
    transform: "rotate(90,90.673589,101.52213)",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#cd1c21",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    href: "#rect2",
    id: "use2-3",
    transform: "rotate(90,68.768216,79.50572)",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#cd1c21",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    href: "#rect2",
    id: "use4",
    transform: "translate(0.27764505,43.952853)",
    style: {
      display: "inline",
      fill: "#cd1c21",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "matrix(-0.0939929,0.39700947,-0.39700947,-0.0939929,187.13135,90.269963)",
    style: {
      strokeWidth: 4.18644,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 1,
      fill: "#f2f2f2",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5.44461,
      strokeLinecap: "butt",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers fill stroke"
    },
    id: "path16",
    cx: 121.67076,
    cy: 159.06808,
    r: 34.983711
  }), /*#__PURE__*/React.createElement("g", {
    id: "g16",
    transform: "matrix(-0.13455553,1.2935573,-1.2935573,-0.13455553,394.97607,15.067082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#f9f9f9",
      stroke: "#000000",
      strokeWidth: 4.18644,
      strokeLinecap: "butt",
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    d: "m 154.195,197.56462 c 0,12.08312 -9.99419,21.87843 -22.32266,21.87843 -12.32847,0 -22.32266,-9.79531 -22.32266,-21.87843 0,-12.08312 9.99419,-21.87843 22.32266,-21.87843 12.32847,0 22.32266,9.79531 22.32266,21.87843 z",
    nodetypes: "sssss"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4.18644,
      strokeDasharray: "none",
      paintOrder: "stroke markers fill"
    },
    label: "right",
    d: "m 147.61937,213.06975 c -4.06047,-3.96193 -6.57368,-9.44588 -6.57368,-15.50513 0,-6.05925 2.51321,-11.5432 6.57368,-15.50513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-9-0",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4.18644,
      strokeDasharray: "none",
      paintOrder: "stroke markers fill"
    },
    label: "left",
    d: "m 116.12504,182.05923 c 4.06063,3.96194 6.57395,9.44601 6.57395,15.50539 v 0 c 0,6.05938 -2.51332,11.54345 -6.57395,15.50539"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 4.18644,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    d: "m 131.7096,175.68305 -0.21691,44.4665",
    id: "path5",
    nodetypes: "cc",
    label: "line"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 4.22349,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke markers fill"
    },
    d: "m 154.65224,198.02469 -45.28556,-0.21677",
    id: "path15",
    nodetypes: "cc",
    label: "line"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#cd1c21",
      strokeWidth: 2.264,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers fill stroke"
    },
    d: "M 90.788211,101.23663 104.98132,83.503142",
    id: "path17",
    nodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#cd1c21",
      strokeWidth: 2.164,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers fill stroke"
    },
    d: "m 83.347324,92.296458 7.551946,8.995702",
    id: "path18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameTime);
export default __webpack_public_path__ + "static/media/gameTime.0c0570b0dbec84dd2b0e9379d6c177e8.svg";
export { ForwardRef as ReactComponent };